import { observer } from "mobx-react-lite";
import styled from "styled-components";
import PageWrap from "../components/PageWrap";
import PageHeader, { headerHeight } from "../components/PageHeader";

const noticeBg = require("../../assets/images/user/notice.jpg");

const ScrollArea = styled.div`
  height: calc(100% - ${headerHeight});
  overflow: auto;
  background: #fff;
`;

const Img = styled.img`
  width: 100%;
  display: block;
`;

const UserNotice = () => (
  <PageWrap>
    <PageHeader title="用户须知" />
    <ScrollArea>
      <Img src={noticeBg} alt="用户须知" />
    </ScrollArea>
  </PageWrap>
);

export default observer(UserNotice);
